/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { getEmployees, getPositions, positionChange, hideModal } from "actions";
import toastr from "toastr";
import Select from "react-select";

class PositionChange extends Component {
  state = {
    selectedPosition: null,
    positions: [],
  };

  componentDidMount() {
    this.getPositions();
  }

  getPositions() {
    this.props.getPositions(
      null,
      this.onBegin,
      this.onFetchPositionSuccess,
      this.onError
    );
  }

  getEmployees = () => {
    this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
  };

  positionChange() {
    if (this.state.selectedPosition === null) {
      toastr.error("position alanı boş bırakılamaz");
      return false;
    }

    let formData = {
      employeeId: this.props.employee.id,
      positionId: this.state.selectedPosition,
    };

    this.props.positionChange(
      this.props.employee.id,
      formData,
      this.onBegin,
      this.onPositionChangeSuccess,
      this.onError
    );
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
  };

  onPositionChangeSuccess = (res) => {
    toastr.success(i18n.t("10570"));
    this.getEmployees();
    this.props.onProcessEnd();
    this.props.hideModal();
  };

  onFetchPositionSuccess = (res) => {
    this.props.onProcessEnd();
    this.setState({ positions: res.data.data.positions });
  };

  renderFormHeader() {
    return null;
  }

  renderFormBody() {
    return (
      <div>
        <span>
          <b>{this.props.employee.fullname}</b> -{" "}
          {this.props.employee.position?.name}
        </span>

        <form>
          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="name">
                <Trans desc="Lütfen yeni bir pozisyon seçiniz"></Trans>
              </label>
              <Select
                options={this.state.positions.map((position) => {
                  return { value: position.id, label: position.name };
                })}
                onChange={(e) => this.setState({ selectedPosition: e.value })}
                placeholder={i18n.t("10521")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderFormFooter() {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn-action btn-blue"
          onClick={() => this.positionChange()}
        >
          <Trans desc="Gönder">10567</Trans>
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.spinner}
        {this.renderFormHeader()}
        {this.renderFormBody()}
        {this.renderFormFooter()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getEmployees,
  positionChange,
  getPositions,
  hideModal,
})(containsLongRunningProcess(requireAuth(PositionChange)));
